import React from 'react';
import ButtonPrimary, { TButtonProps } from 'components/ButtonPrimary';
import restyle from 'components/../restyler';
import defaultStyles from './buttonDanger.module.css';

const ButtonDanger: React.FC<TButtonProps> = ({ styles, ...props }) => (
  <ButtonPrimary {...props} styles={restyle(defaultStyles, styles)} />
);

export default ButtonDanger;
